import React, {useEffect, useState} from 'react';
import {Pagination, Select} from "antd";
import Accordion from "react-bootstrap/Accordion";
import {useDispatch, useSelector} from "react-redux";
import {
    checkIsUpdateInstruction,
    deleteItemTriggerConfirmation,
    getAllDevicesByInstallationId,
    getAllInstallationsWithoutPag,
    getAllLocationItem,
    getAllTriggers,
    getTriggersPagination,
    installationsLoad,
    triggersLoader
} from "../../redux-store/selectors";
import {Card, Dropdown, useAccordionButton} from "react-bootstrap";
import arrowUp from "../../images/arrow-up.png";
import arrowDown from "../../images/arrow-down.png";
import {
    fetchAllLocations,
    fetchDevicesByInstallationsID,
    fetchLocationsByInstallationsID,
    fetchTriggersByInstallationsId,
    openDeleteModalTriggers,
    openModalTrigger,
    updateItemTrigger
} from "../../redux-store/triggers";
import {getInstallationsWithoutPag} from "../../redux-store/installations";
import {AiFillEdit} from "react-icons/ai";
import {RiDeleteBin6Line} from "react-icons/ri";
import ellipsis from "../../images/ellipsis-h.png";
import TriggerList from "./TriggerList";
import {fetchDeviceTypes} from "../../redux-store/devices";
import TriggerModal from "./TriggerModal";
import UpdateInstruction from "./UpdateInstruction";
import Loader from "../ApplicationComponent/Loader";
import ConfirmationDeleteTrigger from "./ConfirmationDeleteTrigger";
import {SELECTED_INSTALLATION} from "../../constants/variables";

const {Option} = Select


export const CustomDropDownToggle = React.forwardRef(({children, onClick}, ref) => (
    <button
        className={"btn"}
        ref={ref}
        onClick={(e) => {
            e.preventDefault();
            onClick(e);
        }}
    >
        {children}
    </button>
));

const Triggers = () => {
        const dispatch = useDispatch();
        const installationLoader = useSelector(installationsLoad);
        const installations = useSelector(getAllInstallationsWithoutPag);
        const triggersItem = useSelector(getAllTriggers);
        const {total, pageSize, currentPage} = useSelector(getTriggersPagination)
        const checkIsUpdateForm = useSelector(checkIsUpdateInstruction)
        const fetchLoader = useSelector(triggersLoader)
        const deleteDialog = useSelector(deleteItemTriggerConfirmation)

        const [activeEventKey, setActiveEventKey] = useState(0);
        const [selectData, setSelectData] = useState([]);
        const [selectedValue, setSelectedValue] = useState(null);
        const [idTriggerForDelete, setIdTriggerForDelete] = useState(0)
        const [idTriggerForUpdate, setIdTriggerForUpdate] = useState(0)

        const allDevices = useSelector(getAllDevicesByInstallationId);
        const allLocations = useSelector(getAllLocationItem)

        const CustomToggle = ({eventKey}) => {
            const decoratedOnClick = useAccordionButton(eventKey, () => {
                if (activeEventKey === eventKey) {
                    setActiveEventKey(0);
                } else {
                    setActiveEventKey(eventKey);
                }
            });

            if (eventKey === activeEventKey)
                return <img src={arrowUp} width={20} height={20} onClick={decoratedOnClick} alt={"UP"}/>
            return <img src={arrowDown} width={20} height={20} onClick={decoratedOnClick} alt={"DOWN"}/>
        }

        const fetchTriggersByInstallationId = async (installationId) => {
            dispatch(fetchTriggersByInstallationsId({installationId}));
        }

        useEffect(() => {
            dispatch(getInstallationsWithoutPag());
            dispatch(fetchDeviceTypes())
        }, []);


        useEffect(() => {
            const selectItem = localStorage.getItem(SELECTED_INSTALLATION);
            const selectedData = installations?.map((item, counter) => {
                if (counter === 0) {
                    if(selectItem !== null)
                        handleInstallationSelectChange(JSON.parse(selectItem))
                    else
                        handleInstallationSelectChange({
                            label: item.name,
                            value: item.id
                        })
                }
                return (<Option value={item.id} key={item.id}>{item.name}</Option>)
            });
            setSelectData(selectedData)
        }, [installations]);


        const handleInstallationSelectChange = selectedValue => {
            localStorage.setItem(SELECTED_INSTALLATION,JSON.stringify(selectedValue));
            setSelectedValue(selectedValue);
            fetchTriggersByInstallationId(selectedValue.value);
            dispatch(fetchDevicesByInstallationsID({installationId: selectedValue.value}))
            dispatch(fetchLocationsByInstallationsID({installationId: selectedValue.value}))
            dispatch(fetchAllLocations({installationId: selectedValue.value}))
        }

        const handleShowModal = () => {
            dispatch(openModalTrigger())
        }

        const handleOpenConfirmationModal = (id) => {
            dispatch(openDeleteModalTriggers(id))
            setIdTriggerForDelete(id)
        }

        const handleUpdateItem = (data) => {
            dispatch(openModalTrigger())
            dispatch(updateItemTrigger(data))
            setIdTriggerForUpdate(data.id)
        }

        const getTriggerCard = (trigger) => {
            return (
                <Card key={trigger.id}>
                    <Card.Header>
                        <div className={"d-flex align-items-center"}>
                            <CustomToggle eventKey={trigger.id} trigger={trigger}>Click me!</CustomToggle>
                            <div className={"d-flex justify-content-between w-100 align-items-baseline"}>
                                <span className={"device-accordion-title"}>{trigger.name}</span>
                                <div className={"d-flex align-items-center"}>
                                    <div>
                                        <Dropdown align="end">
                                            <Dropdown.Toggle as={CustomDropDownToggle} id="dropdown-custom-components">
                                                <img src={ellipsis} width={5} height={15} className={"ms-2"}/>
                                            </Dropdown.Toggle>
                                            <Dropdown.Menu>
                                                <Dropdown.Item eventKey="1" className={"update-button-card"}
                                                               onClick={() => handleUpdateItem(trigger)}>
                                                    <AiFillEdit/> Izmjeni
                                                </Dropdown.Item>
                                                <Dropdown.Item eventKey="2" className={"delete-button-card"}
                                                               onClick={() => handleOpenConfirmationModal(trigger.id)}>
                                                    <RiDeleteBin6Line/> Obriši
                                                </Dropdown.Item>
                                            </Dropdown.Menu>
                                        </Dropdown>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div>
                            <span className={"ms-4 text-muted"}>{trigger?.humanReadable}</span>
                        </div>
                    </Card.Header>
                    <Accordion.Collapse eventKey={trigger.id}>
                        <Card.Body>
                            <TriggerList installationId={selectedValue?.value} triggers={trigger} triggerItemId={trigger.id}
                                         eventKey={activeEventKey} allDevices={allDevices} allLocations={allLocations}/>
                        </Card.Body>
                    </Accordion.Collapse>
                </Card>);
        }

        return (
            <>
                <div className={"container-fluid"}>
                    <div className={"row pt-3 pb-3 bottom-line"}>
                        <div className={"col-12 col-md-6 col-lg-6 col-xl-6"}>
                            <div className="d-flex align-items-center installation-select">
                                <label className="home-page-label">Okidači</label>
                                <div className="col-7 col-md-7 col-lg-5 col-xl-4 ant-select-installations">
                                    <Select labelInValue style={{width: "200px"}} loading={installationLoader}
                                            disabled={installationLoader}
                                            onChange={handleInstallationSelectChange} value={selectedValue}>
                                        {selectData}
                                    </Select>
                                </div>
                            </div>
                        </div>
                    </div>
                    {fetchLoader ? <Loader/> : (
                        <>
                            <div className={"row pt-3 d-flex justify-content-center"}>
                                <div className={"col-12 col-md-6 col-lg-4 col-xl-4 text-left"}>
                                    <h4 className={"font-bold"}>{selectedValue?.label}</h4>
                                </div>
                                <div className={"col-12 col-md-6 col-lg-4 col-xl-4 text-right"}>
                                    <button className={"btn btn-location"} onClick={handleShowModal}>Dodaj okidač</button>
                                </div>
                            </div>
                            <div className={"row pt-3 d-flex justify-content-center"}>
                                <div className={"col-12 col-md-8 col-lg-8 col-xl-8"}>
                                    {total !== 0 && (
                                        <div className={"row text-right pt-2 pb-4"}>
                                            <div className={"col-12"}>
                                                <Pagination defaultCurrent={1}
                                                            current={currentPage + 1}
                                                            total={total}
                                                            showSizeChanger={false}
                                                            onChange={(newPage) => {
                                                                dispatch(fetchTriggersByInstallationsId({
                                                                    installationId: selectedValue?.value,
                                                                    page: newPage - 1,
                                                                    pageSize
                                                                }));
                                                            }}/>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                            <div className={"row pt-3 d-flex justify-content-center"}>
                                <div className={"col-12 col-md-8 col-lg-8 col-xl-8"}>
                                    <div className={"device-body-cards"}>
                                        <Accordion defaultActiveKey="0">
                                            {triggersItem.map((item) => getTriggerCard(item))}
                                        </Accordion>
                                    </div>
                                </div>
                            </div>
                        </>
                    )}
                </div>
                {!checkIsUpdateForm && <TriggerModal installationId={selectedValue?.value} triggerItemId={idTriggerForUpdate}/>}
                <UpdateInstruction installationId={selectedValue?.value} eventKey={activeEventKey}/>
                {deleteDialog &&
                <ConfirmationDeleteTrigger installationId={selectedValue?.value} eventKey={idTriggerForDelete}/>}
            </>

        );
    }
;

export default Triggers;
